export const expandSearchTerms = (searchTerm: string): string[] => {
  const searchLower = searchTerm.toLowerCase();
  
  const numberWords: Record<string, string> = {
    '1': 'one', '2': 'two', '3': 'three', '4': 'four', '5': 'five',
    '6': 'six', '7': 'seven', '8': 'eight', '9': 'nine', '10': 'ten',
    'ace': '1', 'one': '1', 'two': '2', 'three': '3', 'four': '4',
    'five': '5', 'six': '6', 'seven': '7', 'eight': '8', 'nine': '9', 'ten': '10'
  };
  
  const suitSynonyms: Record<string, string> = {
    'coins': 'pentacles',
    'coin': 'pentacle',
    'pentacles': 'coins',
    'pentacle': 'coin',
    'wands': 'clubs',
    'clubs': 'wands',
    'swords': 'spades',
    'spades': 'swords',
    'cups': 'hearts',
    'hearts': 'cups'
  };
  
  let expandedTerms = [searchLower];
  
  // Add number/word variations
  Object.keys(numberWords).forEach(key => {
    if (searchLower.includes(key)) {
      expandedTerms.push(searchLower.replace(key, numberWords[key]));
    }
  });
  
  // Add suit variations
  Object.keys(suitSynonyms).forEach(key => {
    if (searchLower.includes(key)) {
      expandedTerms.push(searchLower.replace(key, suitSynonyms[key]));
    }
  });
  
  return expandedTerms;
};

export const searchInText = (searchTerms: string[], text: string): boolean => {
  const textLower = text.toLowerCase();
  
  return searchTerms.some(term => {
    // Use word boundaries for more precise matching
    const regex = new RegExp(`\\b${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'i');
    return regex.test(textLower);
  });
};
